import * as z from "zod";
//#region src/__generated__/internal/dictionaries/zod/dictionaryItemSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const dictionaryItemSchema = z.object({
	code: z.string().nullish().describe("Код значения").meta({ examples: ["MOSKOVSKAYA"] }),
	displayName: z.string().nullish().describe("Отображаемое наименование").meta({ examples: ["Московская железная дорога"] })
}).describe("Элемент справочника");
//#endregion
//#region src/__generated__/internal/dictionaries/zod/dictionariesResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const dictionariesResponseSchema = z.object({
	adjoiningTypes: z.array(dictionaryItemSchema).nullish(),
	applicantTypes: z.array(dictionaryItemSchema).nullish(),
	deadlineControls: z.array(dictionaryItemSchema).nullish().describe("Плашки контроля срока рассмотрения"),
	paymentFlags: z.array(dictionaryItemSchema).nullish().describe("Условия оплаты"),
	plannedWorksTypes: z.array(dictionaryItemSchema).nullish(),
	processingFlags: z.array(dictionaryItemSchema).nullish().describe("Признаки обработки Оператором"),
	railways: z.array(dictionaryItemSchema).nullish(),
	requestSubjects: z.array(dictionaryItemSchema).nullish(),
	statuses: z.array(dictionaryItemSchema).nullish().describe("Статусы рассмотрения"),
	trackFundings: z.array(dictionaryItemSchema).nullish()
}).describe("Справочники формы заявки и фильтров реестра");
//#endregion
//#region src/__generated__/internal/dictionaries/zod/getDictionariesSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getDictionariesStatus200Schema = dictionariesResponseSchema.describe("Справочники формы заявки и фильтров реестра");
const getDictionariesResponseSchema = getDictionariesStatus200Schema;
//#endregion
export { dictionaryItemSchema as i, getDictionariesStatus200Schema as n, dictionariesResponseSchema as r, getDictionariesResponseSchema as t };

//# sourceMappingURL=getDictionariesSchema2.js.map